import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { user, loading, isAuthenticated, requiresPasswordChange } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-pt-background flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-pt-primary animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Force password change redirect
  if (requiresPasswordChange) {
    return <Navigate to="/set-password" replace />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(user?.role)) {
    if (user?.role === 'trainer') {
      return <Navigate to="/trainer" replace />;
    } else if (user?.role === 'trainee') {
      return <Navigate to="/trainee" replace />;
    } else if (user?.role === 'gym_owner') {
      return <Navigate to="/owner" replace />;
    }
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
